export const validateCardholderName = (inputString: string) => {
  const regexPattern = /^(['.A-Za-z’-]+ ['.A-Za-z’-]+)$/;
  return regexPattern.test(inputString);
};
